import signing from './letters-signing-ms'

/** Surat keputusan (perancangan P4-2a, reka bentuk §6): Tetapan → Perancangan → Surat keputusan. */
export default {
  letters: {
    signing,
    settings: {
      title: 'Surat keputusan',
      description:
        'Benarkan pegawai membuat surat keputusan daripada sesuatu kes. Kepala surat di bawah dicetak di bahagian atas setiap surat, dan penandatangan ialah orang yang boleh menandatangani surat.',
      enabled: 'Tawarkan surat keputusan pada kes',
      enabledHint:
        'Dimatikan secara lalai. Tiada surat dijana melainkan pegawai memintanya selepas keputusan dibuat. Templat surat yang disediakan buat masa ini adalah sementara: belum disemak dari segi undang-undang atau disahkan oleh mana-mana majlis, dan PDF-nya membawa tanda DRAF.',
      requireSignature: 'Surat mesti ditandatangani sebelum dikongsi',
      requireSignatureOn:
        'Hanya surat yang telah ditandatangani boleh dikongsi dengan pemohon. Tanpa sauh kepercayaan, setiap surat bertandatangan menunggu perkongsian yang jelas oleh pegawai.',
      requireSignatureOff:
        'Surat yang dijana boleh dikongsi dengan pemohon sebaik sahaja dikeluarkan, tanpa tandatangan.',
      councilMs: 'Nama majlis (Bahasa Melayu)',
      councilEn: 'Nama majlis (Bahasa Inggeris, pilihan)',
      councilEnHint: 'Digunakan hanya bersama sumber rasmi dalam Bahasa Inggeris. Surat ditulis dalam Bahasa Melayu.',
      addressLines: 'Alamat',
      addressLinesHint: 'Tulis satu baris alamat pada setiap baris, selebih-lebihnya lima baris.',
      phone: 'Telefon',
      email: 'E-mel',
      website: 'Laman web',
      footer: 'Pengaki',
      logo: 'Logo majlis',
      logoHint: 'Fail PNG atau JPEG tidak melebihi 256 KiB dan 2048 piksel pada setiap sisi. JPEG CMYK tidak diterima.',
      logoRemove: 'Buang logo',
      logoType: 'Pilih fail PNG atau JPEG.',
      logoSize: 'Logo tidak boleh melebihi 256 KiB.',
      logoAlt: 'Logo majlis',
      signatories: 'Penandatangan',
      signatoriesHint: 'Sehingga sepuluh orang. Pegawai memilih seorang semasa menyediakan surat.',
      signatoryNone: 'Belum ada penandatangan.',
      signatoryName: 'Nama',
      signatoryTitle: 'Jawatan',
      signatoryAdd: 'Tambah penandatangan',
      signatoryRemove: 'Buang',
      previewTitle: 'Pratonton kepala surat',
      previewNote: 'Ini hanya menunjukkan kepala surat seperti yang akan dibawa oleh surat. Ini bukan surat.',
      previewEmpty: 'Isi kepala surat untuk melihatnya di sini.',
      save: 'Simpan tetapan surat',
      saving: 'Menyimpan…',
      saved: 'Tetapan surat disimpan.',
      problems: {
        tooLong: 'Teks ini terlalu panjang.',
        addressLinesTooMany: 'Gunakan selebih-lebihnya lima baris alamat.',
        emailInvalid: 'Masukkan satu alamat e-mel.',
        websiteInvalid: 'Masukkan alamat yang bermula dengan http:// atau https://.',
        signatoriesTooMany: 'Gunakan selebih-lebihnya sepuluh penandatangan.',
        signatoryIncomplete: 'Setiap penandatangan memerlukan nama dan jawatan.',
      },
      trustAnchors: {
        title: 'Sauh kepercayaan',
        hint: 'Pihak berkuasa perakuan yang dipercayai oleh majlis ini, dalam format PEM, selebih-lebihnya sepuluh. Rantaian perakuan surat bertandatangan disemak dengan senarai ini sahaja. Pembatalan perakuan belum disemak, dan rantaian yang menggunakan kekangan yang tidak dikuatkuasakan oleh gisify dibaca sebagai tidak dipercayai.',
        none: 'Belum ada sauh kepercayaan.',
        addFile: 'Tambah fail perakuan',
        paste: 'Atau tampal perakuan',
        pasteAdd: 'Tambah perakuan yang ditampal',
        remove: 'Buang {{name}}',
        unnamed: 'Perakuan tanpa nama umum',
        unread: 'Belum dibaca. Perakuan ini disemak apabila anda menyimpan.',
        fingerprint: 'Cap jari SHA-256 {{sha256}}',
        validUntil: 'Sah sehingga {{date}}',
        expired:
          'Tamat tempoh pada {{date}}. Penandatangan yang hanya sampai ke sauh ini dibaca sebagai tidak dipercayai.',
        notPem:
          'Itu bukan satu perakuan PEM. Perakuan mesti bermula dengan BEGIN CERTIFICATE dan berakhir dengan END CERTIFICATE.',
        tooLarge: 'Perakuan tidak boleh melebihi 16 KiB.',
        tooMany: 'Gunakan selebih-lebihnya sepuluh sauh kepercayaan.',
        duplicate: 'Perakuan itu sudah disenaraikan.',
        readFailed: 'Fail itu tidak dapat dibaca.',
      },
    },
    panel: {
      title: 'Surat keputusan',
      intro:
        'Buat surat keputusan daripada satu keputusan pada kes ini. Surat kekal sebagai draf sehingga seorang pegawai mengeluarkannya; setelah dikeluarkan, ia disimpan dalam kes.',
      offers: 'Surat yang boleh disediakan',
      noOffers: 'Belum ada surat yang ditawarkan untuk kes ini.',
      offerFor: 'Untuk keputusan pada langkah {{seq}}',
      prepare: 'Sediakan',
      provisional:
        'Templat sementara: belum disemak dari segi undang-undang atau disahkan oleh mana-mana majlis. PDF membawa tanda DRAF.',
      listTitle: 'Surat pada kes ini',
      none: 'Belum ada surat yang disediakan.',
      newest: 'Terbaharu untuk keputusan ini',
      forDecision: 'Keputusan pada langkah {{seq}}',
      shared: 'Dikongsi dengan pemohon',
      notShared: 'Tidak dikongsi',
      openDraft: 'Buka draf',
      issue: 'Keluarkan',
      discard: 'Buang',
      share: 'Kongsi dengan pemohon',
      hide: 'Sembunyikan daripada pemohon',
      rendering: 'Surat sedang dibuat…',
      renderingSlow: 'Ini mengambil masa lebih lama daripada jangkaan. Semak semula sebentar lagi.',
      retry: 'Semak semula',
      failed: 'Surat tidak dapat dibuat ({{code}}).',
      failedGlyph:
        'Surat tidak dapat dibuat: {{field}} mengandungi aksara yang tiada dalam fon surat. Betulkannya dan sediakan surat sekali lagi, atau muat naik surat itu sebagai dokumen.',
      failedGlyphTemplate:
        'Surat tidak dapat dibuat: {{field}} mengandungi aksara yang tiada dalam fon surat. Maklumkan kepada pentadbir, dan muat naik surat itu sebagai dokumen buat masa ini.',
      field: {
        applicantName: 'nama pemohon',
        applicantFirm: 'firma pemohon',
        caseReference: 'rujukan kes',
        decisionNumber: 'nombor keputusan',
        decisionDate: 'tarikh keputusan',
        councilName: 'nama majlis pada kepala surat',
        letterheadAddress: 'alamat pada kepala surat',
        letterheadContact: 'butiran hubungan pada kepala surat',
        letterheadFooter: 'pengaki kepala surat',
        signatoryName: 'nama penandatangan',
        signatoryTitle: 'jawatan penandatangan',
        read: 'nilai keputusan "{{alias}}"',
        blockLabel: 'label bahagian {{n}} templat surat',
        blockText: 'teks bahagian {{n}} templat surat',
        unknown: 'satu bahagian surat',
      },
      signatureRequired:
        'Muat turun surat yang dikeluarkan, tandatangani dengan alat anda sendiri, dan muat naiknya di sini.',
      downloadIssued: 'Muat turun surat yang dikeluarkan',
      downloadSigned: 'Muat turun surat bertandatangan',
      uploadSigned: 'Muat naik surat bertandatangan',
      uploadSignedAgain: 'Muat naik surat bertandatangan sekali lagi',
      uploading: 'Memuat naik surat bertandatangan… {{percent}}%',
      uploadFinalizing: 'Menyemak fail yang dimuat naik…',
      verifying: 'Menyemak tandatangan…',
      signedShared: 'Dikongsi',
      signedSharedAuto: 'Dikongsi secara automatik',
      issuedStillShown:
        'Pemohon masih melihat surat yang dikeluarkan. Berkongsi surat bertandatangan akan menggantikannya.',
      ordinaryFallback: 'Fail ini masih boleh dimuat naik sebagai dokumen biasa, yang tidak dipautkan kepada apa-apa.',
      noOrdinaryFallback:
        'Pada peringkat kes ini, fail ini tidak boleh disimpan sebagai dokumen berasingan. Tandatangani semula fail yang dikeluarkan dan muat naik fail itu.',
      signed: {
        kind: {
          pades: 'Jenis tandatangan: PAdES',
          not_pades: 'Jenis tandatangan: tandatangan PDF yang bukan PAdES',
        },
        chain: {
          trusted: 'Perakuan: berantai kepada pihak berkuasa perakuan yang dikonfigurasi untuk majlis ini',
          untrusted: 'Perakuan: tidak berantai kepada pihak berkuasa perakuan yang dikonfigurasi',
          unchecked: 'Perakuan: tidak disemak dengan mana-mana pihak berkuasa perakuan',
        },
        signer: 'Penandatangan: {{name}}',
        signerUnknown: 'Penandatangan: tidak direkodkan',
        issuer: 'Dikeluarkan oleh: {{name}}',
        serial: 'Nombor siri: {{serial}}',
        validity: 'Sah dari {{from}} hingga {{to}}',
        fingerprint: 'Cap jari SHA-256: {{sha256}}',
        signingTime: 'Masa menandatangani, seperti yang dinyatakan oleh alat penandatangan sendiri: {{date}}',
        signatory: {
          match: 'Penandatangan pilihan: nama pada perakuan sepadan dengan penandatangan yang dipilih',
          mismatch: 'Penandatangan pilihan: nama pada perakuan tidak sepadan dengan penandatangan yang dipilih',
          not_comparable:
            'Penandatangan pilihan: perakuan ini tidak dapat dibandingkan dengan penandatangan yang dipilih',
        },
        stamp: 'Cop: halaman {{page}}, {{percent}}% daripada halaman',
        noStamp: 'Tiada cop yang kelihatan',
        noRevocation: 'Sama ada perakuan ini telah dibatalkan tidak disemak.',
        limit:
          'gisify menyemak bahawa kandungan halaman surat yang dikeluarkan tidak ditulis semula; gisify tidak memaparkan fail ini, dan cop tandatangan boleh menutup teks di dalam kotaknya.',
      },
      warning: {
        chain_unchecked:
          'Tiada sauh kepercayaan dikonfigurasi, jadi perakuan ini tidak disemak dengan mana-mana pihak berkuasa perakuan. Perakuan swatandatangan juga sampai ke tahap ini.',
        chain_untrusted:
          'Perakuan ini tidak berantai kepada pihak berkuasa perakuan yang dikonfigurasi, atau rantaiannya tidak dapat difahami. Itu sahaja tidak bermakna perakuan ini tidak sah.',
        signatory_mismatch:
          'Nama pada perakuan ini tidak sepadan dengan penandatangan yang dipilih. Pastikan orang yang betul telah menandatangani.',
        signatory_not_comparable:
          'Perakuan ini tidak dapat dibandingkan dengan penandatangan yang dipilih. Pastikan orang yang betul telah menandatangani.',
        signer_ic_number:
          'Perakuan ini mengandungi sesuatu yang kelihatan seperti nombor KP. Berkongsi surat ini akan mendedahkannya kepada pemohon.',
        signature_stamp_large:
          'Cop tandatangan menutup {{percent}}% daripada halaman {{page}}. Buka surat bertandatangan dan pastikan cop itu tidak menutup apa-apa sebelum berkongsi.',
        decision_superseded: 'Keputusan yang lebih baharu menggantikan keputusan yang menjadi asas surat ini.',
        letter_superseded:
          'Surat yang lebih baharu bagi keputusan ini telah dikeluarkan. Salinan ini ialah surat yang lama, jadi teksnya mungkin sudah lapuk.',
      },
      refusal: {
        signed_letter_not_derived: 'Fail ini bukan surat yang dikeluarkan dengan tandatangan ditambah.',
        signed_letter_overrides_content:
          'Fail ini mengubah lebih banyak bahagian surat daripada yang diperlukan oleh tandatangan.',
        signed_letter_unsupported_structure:
          'Struktur fail ini tidak dapat disemak. Jika sebab atau cop tandatangan mengandungi perkataan xref, startxref atau trailer, tandatangani semula fail yang dikeluarkan tanpa perkataan itu.',
        signature_invalid:
          'Tandatangan dalam fail ini gagal disahkan. Fail ini mungkin telah berubah selepas ditandatangani.',
        signature_algorithm_refused:
          'Tandatangan ini menggunakan algoritma atau saiz kunci yang tidak diterima oleh gisify. Tandatangani semula fail yang dikeluarkan dengan yang lain.',
        stage_held_externally: 'Sistem lain sedang memegang kes ini, jadi surat bertandatangan tidak diterima.',
        stage_locked: 'Kes ini tidak lagi menerima surat bertandatangan.',
        too_large: 'Fail ini melebihi had saiz bagi surat bertandatangan.',
        upload_missing: 'Fail yang dimuat naik tidak ditemui. Muat naik sekali lagi.',
        issued_letter_unreadable:
          'Surat yang dikeluarkan tidak dapat dibaca untuk dibandingkan dengan fail ini. Cuba lagi, dan maklumkan kepada pentadbir jika berulang.',
        verify_timeout: 'Semakan mengambil masa terlalu lama dan telah dihentikan. Muat naik fail sekali lagi.',
        dispatch_failed: 'Semakan tidak dapat dimulakan. Muat naik fail sekali lagi.',
        unknown: 'Fail ini tidak dapat diterima. Tandatangani semula fail yang dikeluarkan dan muat naik fail itu.',
      },
      uploadRefused: {
        too_large: 'Surat bertandatangan ditolak: fail ini melebihi had saiz bagi surat bertandatangan.',
        empty: 'Surat bertandatangan ditolak: fail ini kosong.',
        unsupported_type: 'Surat bertandatangan ditolak: fail ini bukan PDF.',
        missing: 'Surat bertandatangan ditolak: fail ini tidak sampai ke pelayan. Muat naik sekali lagi.',
        size_mismatch:
          'Surat bertandatangan ditolak: saiz fail yang diterima tidak sama dengan saiz yang dihantar. Muat naik sekali lagi.',
        unreadable: 'Surat bertandatangan ditolak: fail yang diterima tidak dapat dibaca. Muat naik sekali lagi.',
        unknown: 'Surat bertandatangan ditolak. Muat naik fail sekali lagi.',
      },
      shareDialog: {
        title: 'Kongsi surat bertandatangan',
        intro:
          'Pemohon akan melihat surat bertandatangan menggantikan surat yang dikeluarkan. Baca setiap amaran sebelum berkongsi.',
        none: 'Tiada amaran bagi tandatangan ini.',
        confirmIc: 'Saya mengesahkan surat ini mendedahkan nombor KP penandatangan kepada pemohon.',
        submit: 'Kongsi',
        issued: {
          title: 'Kongsi surat yang dikeluarkan',
          intro: 'Pemohon akan melihat surat yang dikeluarkan ini. Baca setiap amaran sebelum berkongsi.',
          none: 'Tiada amaran bagi surat ini.',
        },
      },
      warnCommunicated:
        'Tarikh dimaklumkan pada keputusan ini lebih awal daripada hari ini. Berkongsi sekarang tidak mengubahnya.',
      loadFailed: 'Surat tidak dapat dimuatkan.',
      status: {
        rendering: 'Sedang dibuat',
        draft: 'Draf',
        failed: 'Gagal',
        issued: 'Dikeluarkan',
        discarded: 'Dibuang',
        expired: 'Tamat tempoh',
      },
      held: {
        title: 'E-mel keputusan yang menunggu surat',
        body: 'Pemohon dihantar e-mel tentang sesuatu keputusan sebaik sahaja suratnya dikongsi. Anda boleh menghantar e-mel itu sekarang tanpa menunggu.',
        item: 'Keputusan pada langkah {{seq}}',
        release: 'Hantar e-mel sekarang',
        released: 'E-mel akan dihantar sebentar lagi.',
      },
      dialog: {
        title: 'Sediakan surat keputusan',
        template: 'Surat: {{template}}',
        signatory: 'Penandatangan',
        pick: 'Pilih penandatangan',
        none: 'Belum ada penandatangan. Pentadbir menambahnya di Tetapan → Perancangan.',
        submit: 'Sediakan surat',
        cancel: 'Batal',
        note: 'Surat dibuat daripada keputusan ini dan disimpan sebagai draf untuk anda buka.',
      },
    },
  },
  errors: {
    letters_off: 'Surat keputusan dimatikan. Pentadbir menghidupkannya di Tetapan → Perancangan.',
    template_not_offered: 'Surat itu tidak ditawarkan pada serahan ini.',
    letterhead_incomplete: 'Kepala surat belum lengkap. Pentadbir melengkapkannya di Tetapan → Perancangan.',
    letter_value_missing: 'Serahan ini tidak mempunyai nilai yang diperlukan oleh surat.',
    letter_not_found: 'Surat itu tidak ditemui pada serahan ini.',
    letter_not_draft: 'Surat itu bukan lagi draf. Muat semula kes dan cuba lagi.',
    letter_not_issued: 'Surat itu belum dikeluarkan.',
    letter_draft_stale:
      'Keputusan yang lebih baharu menggantikan keputusan yang menjadi asas draf ini, jadi draf ini tidak boleh dikeluarkan. Jika surat itu masih tersenarai di bawah Surat yang boleh disediakan, sediakannya sekali lagi. Jika tidak tersenarai, surat itu tidak lagi boleh disediakan pada serahan ini.',
    letter_draft_changed: 'Draf yang disimpan bukan yang telah dijana. Sediakan surat sekali lagi.',
    signature_required: 'Surat mesti ditandatangani sebelum dikongsi.',
    signatory_unknown: 'Penandatangan itu tiada pada kepala surat.',
    invalid_letter_request: 'Permintaan surat itu tidak sah.',
    held_email_not_found: 'Tiada e-mel keputusan yang menunggu surat pada langkah itu.',
    letter_imported: 'Surat itu datang daripada sistem lain, jadi ia tidak boleh ditandatangani di sini.',
    letter_signature_verifying: 'Salinan bertandatangan surat itu masih disemak. Tunggu keputusannya.',
    letter_already_signed: 'Surat itu sudah mempunyai salinan bertandatangan yang disahkan.',
    letter_not_verifying: 'Salinan bertandatangan itu tidak lagi disemak. Muat semula kes.',
    signature_warning_unacknowledged: 'Setiap amaran mesti diakui sebelum surat dikongsi.',
  },
}
